// extracted by mini-css-extract-plugin
module.exports = {"SelectButton":"FpxTable--SelectButton--2jqpgJb","TableContainer":"FpxTable--TableContainer--2i_ti7x","FpxTableBox":"FpxTable--FpxTableBox--1KfAPm6"};